import styled from 'styled-components';
import {
  MOBILE,
} from '@minerva-analytics/pantheon';
import {
  RED,
  GRAY,
  DARK_GRAY,
  WHITE
} from '../../theme';

const ArticlesContainer = styled.div`
  height: 100%;
  width: 100%;
`;


const Image = styled.img`
  width: auto;
  height: 8rem;
  display: block;
  margin-left: auto;
  margin-right: auto;
  margin-bottom: 20px;
  margin-top: 20px;
`
const PageTitle = styled.h1`
  text-align: center;
  font-size: 42px;
  font-family: 'Abril Fatface', cursive;
  line-height: 54px;
  letter-spacing: 1.05px;
  width: 70%;
  margin: 0 auto;
  @media (max-width: ${MOBILE}) {
    font-size: 32px;
    line-height: 40px;
  }
`

const HighlightedTitle = styled(PageTitle) `
  color: ${RED};
  display: inline;
`

const theme = {
  ghostAuthor: `
    letter-spacing: 1.1px; 
    font-weight: 700; 
    font-family: 'Roboto Bold'; 
    font-size: 1.25rem; 
    line-height: 1.5rem;
    color: ${GRAY};
  `,
  ghostReadTime: `
    text-transform: uppercase; 
    letter-spacing: 1.3px; 
    font-size: 1.125rem;
    font-weight: 700; 
    font-family: 'Avenir Next Condensed', sans-serif;
    line-height: 1.6rem;
  `,
  SubTitle: `
    &&&{
      color: ${DARK_GRAY};
      font-family: 'Inter';
      font-size: 2.0rem; 
      line-height: 2.5rem; 
      letter-spacing: 0.5px;
    }
  `,
  ghostFeaturedAuthor: `
    color: ${WHITE};
  `,
  ghostFeaturedPublished: `
    color: ${WHITE};
    font-family: 'Inter', sans-serif;
    letter-spacing: 0.45px;
  `,
  ghostPublished: `
    color: ${GRAY};
  `,
  ghostFeaturedBlurb: `
    font-family: 'Inter', sans-serif;
    letter-spacing: 0.45px;
    line-height: 26px;
  `
};

export {
  ArticlesContainer,
  theme,
  PageTitle,
  HighlightedTitle,
  Image
};
